import React from "react";

function DmDetailed() {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      {/* GLOW BACKGROUNDS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-orange-500/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="bg-white dark:bg-[#1a1a1a] p-10 md:p-16 rounded-[2rem] border border-gray-100 dark:border-gray-800 shadow-xl shadow-gray-500/5">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-8">
            Digital Marketing Services That Generate Leads, Traffic & Business
            Growth
          </h2>
          <div className="text-gray-600 dark:text-gray-400 text-md space-y-6">
            <p>
              At Web X Secure, we provide result-driven digital marketing
              services designed to help businesses increase online visibility,
              generate qualified leads, improve brand awareness, and maximize
              return on investment. Our marketing strategies combine data
              analysis, audience targeting, content marketing, paid advertising,
              and search engine optimization to achieve measurable business
              growth.
            </p>

            <p>
              Our team specializes in Search Engine Optimization (SEO), Google
              Ads, Meta Ads, Social Media Marketing, YouTube Marketing,
              Performance Marketing, Local SEO, and Lead Generation campaigns.
              Every strategy is customized according to business goals, target
              audience, competition, and industry requirements.
            </p>

            <p>
              Through advanced keyword research, content optimization, technical
              SEO, conversion rate optimization, and audience segmentation, we
              help businesses attract highly relevant traffic that converts into
              customers. Our focus is not just increasing website visitors but
              generating measurable business results.
            </p>

            <p>
              We continuously monitor campaign performance, analyze user
              behavior, track conversions, and optimize marketing activities to
              improve ROI. Using detailed reporting and analytics, clients gain
              complete visibility into their marketing performance and growth
              opportunities.
            </p>

            <p>
              Whether you are a startup, local business, e-commerce brand,
              educational institute, or enterprise organization, our digital
              marketing solutions are designed to help you reach the right
              audience, improve online presence, and achieve sustainable
              business growth.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DmDetailed;
